import { CloseOutlined } from "@ant-design/icons";
import { Button, Checkbox, DatePicker, Form, message, Popconfirm, Select, Space, TimePicker, Row, Col } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import dayjs from "dayjs";
import { SelectClient } from "../../controls";
import { fmtTime, RECORD_PASS_VID, recordPassVidOptions, strDate2Server } from "../../extensions/utils";
import { isMobile } from '../../extensions/design';

const RecordsSmart = ({ onClose, recordPassVidDefault }) => {
  const [loading, setLoading] = useState(false);
  const [item, setItem] = useState(() => {
    const savedMaintainServiceOrder = localStorage.getItem('recordsSmart_maintainServiceOrder');
    const maintainServiceOrder = savedMaintainServiceOrder === 'true';
    const savedAllowPausesBetweenServices = localStorage.getItem('recordsSmart_allowPausesBetweenServices');
    const allowPausesBetweenServices = savedAllowPausesBetweenServices === null ? true : savedAllowPausesBetweenServices === 'true';
    return {
      date: dayjs(),
      time: null,
      client: null,
      delay: 0,
      productIds: [],
      maintainServiceOrder,
      allowPausesBetweenServices,
      passVid: recordPassVidDefault ?? RECORD_PASS_VID.ByAbon,
    };
  });
  const [form] = Form.useForm();
  const [products, setProducts] = useState([]);

  const getProducts = () => {
    serverFetch("product/forsale?vid=1&active=true")
      .then(data => setProducts(data.map(i => ({ label: i.name, value: i.id, duration: i.duration}))))
      .catch(e => message.error(e.userMessage))
  }
    
  useEffect(getProducts, [])

  const onCancel = () => onClose(false)

  const handleSave = () => {
    const newItem = {...item, clientId: item.client.value, date: strDate2Server(item.date), time: fmtTime(item.time)};
    setLoading(true);
    serverFetch("record/smart", { method: "POST", bodyData: newItem })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(() => form.setFieldsValue(item), []);

  useEffect(() => {
    if (recordPassVidDefault === undefined) return;
    setItem((prev) => ({ ...prev, passVid: recordPassVidDefault }));
    form.setFieldValue("passVid", recordPassVidDefault);
  }, [recordPassVidDefault, form]);

  const onValuesChange = value => {
    const newItem = {...item, ...value};
    setItem(newItem);
    // Сохраняем maintainServiceOrder и allowPausesBetweenServices в localStorage при изменении
    if ('maintainServiceOrder' in value) {
      localStorage.setItem('recordsSmart_maintainServiceOrder', String(value.maintainServiceOrder));
    }
    if ('allowPausesBetweenServices' in value) {
      localStorage.setItem('recordsSmart_allowPausesBetweenServices', String(value.allowPausesBetweenServices));
    }
  }

  const onAddProduct = id => setItem({...item, productIds: [...item.productIds, id]})
  const onDelProduct = id => setItem({...item, productIds: item.productIds.filter(i => i !== id)})

  // Вычисляем суммарное время выбранных услуг
  const totalDuration = item.productIds.reduce((sum, productId) => {
    const product = products.find(p => p.value === productId);
    return sum + (product?.duration || 0);
  }, 0);

  // Форматируем время в часы и минуты
  const formatDuration = (minutes) => {
    if (!minutes) return '0 мин';
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours > 0 && mins > 0) {
      return `${hours} ч ${mins} мин`;
    } else if (hours > 0) {
      return `${hours} ч`;
    } else {
      return `${mins} мин`;
    }
  };

  const divClient = <Form.Item label="Клиент" className={isMobile ? "record-form-item-with-margin-top-mobile" : null} name="client">
    <SelectClient placeholder="Выберите клиента" value={null} defOptions={[]} className="records-client-product-select-mobile" />
  </Form.Item>

  const divProduct = <>
    <Form.Item label="Услуги" className={isMobile ? "record-form-item-with-margin-top-mobile" : null }>
      <Select 
        showSearch
        filterOption={(input, option) => option?.label?.toLowerCase().includes(input.toLowerCase())}
        options={products} 
        placeholder="Добавить услугу" 
        onChange={id => onAddProduct(id)} 
        value={null}
        className={isMobile ? "records-client-product-select-mobile" : null }
      />
    </Form.Item>
    {item.productIds.map(id => <Form.Item label=" " key={id} className={isMobile ? "record-form-item-with-margin-top-mobile" : null}>
      <Select open={false} options={products.filter(p => p.value === id)} value={id} allowClear onClear={() => onDelProduct(id)} className="records-client-product-select-mobile"/>      
    </Form.Item>)}
    {totalDuration > 0 && (
      <Form.Item label=" " cclassName={isMobile ? "record-form-item-with-margin-bottom" : null }>
        <div style={{fontSize: 12, color: '#666'}}>Суммарное время: {formatDuration(totalDuration)}</div>
      </Form.Item>
    )}
  </>

  const canSave = item.date && item.client && item.productIds.length > 0;
    
  return <div className="sport-modal">
    <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onCancel()}>
      <div className="sport-modal-content" onMouseDown={e => e.stopPropagation()}>
        <div className={(isMobile) ? "sport-modal-title" : "client-modal-title"} style={{marginBottom: 0}}>
          <span>Смарт запись</span>
          <CloseOutlined
            className="sport-section-title-close" 
            onClick={() => onClose()} style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}                
          />
        </div>
        <Form form={form} onValuesChange={onValuesChange} wrapperCol={isMobile ? {} : { span: 24 }}
           colon={false} disabled={loading} layout={isMobile ? "inline" : "horizontal"} labelCol={isMobile ? {span: 4} : { span: 6 }}>
        { isMobile ? (
          <>
            <Form.Item className="records-form-item-mobile">
              <Row align="middle" className="records-row-mobile">
                <Col>
                  <Form.Item label="Дата" name="date" className="record-form-item-with-margin-top-mobile">
                    <DatePicker format="DD.MM.YYYY" className="record-date-picker-mobile" />
                  </Form.Item>
                </Col>
                <Col>
                  <Form.Item label="Время" name="time" className="record-form-item-with-margin-top-mobile">
                    <TimePicker format="HH:mm" className="records-small-input-mobile" />
                  </Form.Item>
                </Col>
              </Row>
            </Form.Item>
            {divClient}
            {divProduct}
            <Form.Item label=" " className="records-form-item-mobile" name="maintainServiceOrder" valuePropName="checked" ><Checkbox>Сохранить порядок услуг</Checkbox></Form.Item>
            <Form.Item label=" " className="records-form-item-mobile" name="allowPausesBetweenServices" valuePropName="checked" ><Checkbox disabled={!item.maintainServiceOrder}>Разрешать паузы между услугами</Checkbox></Form.Item>
            <Form.Item label="Вид прохода" className="records-form-item-mobile" name="passVid">
              <Select options={recordPassVidOptions} />
            </Form.Item>
              <Space>
                {!item.time ? (
                  <Popconfirm
                    title="Подтверждение"
                    description="Время не выбрано, записать на доступное время?"
                    onConfirm={handleSave}
                    okText="Да"
                    cancelText="Нет"
                  >
                    <Button className="sport-btn record-form-buttons-mobile" disabled={!canSave}>Записать</Button>
                  </Popconfirm>
                ) : (
                  <Button className="sport-btn record-form-buttons-mobile" onClick={handleSave} disabled={!canSave} >Записать</Button>
                )}
                <Button className="sport-btn record-form-buttons-mobile" onClick={onCancel}>Отмена</Button>
              </Space>
          </>
        ) : (
          <>
            <Form.Item label="Дата" name="date" ><DatePicker format="DD.MM.YYYY"/></Form.Item>
            <Form.Item label="Время" name="time"><TimePicker format="HH:mm" className="record-time"/></Form.Item>
            {divClient}
            {divProduct}
            <Form.Item label={isMobile ? null : " "} name="maintainServiceOrder" valuePropName="checked" ><Checkbox>Сохранить последовательность услуг</Checkbox></Form.Item>
            <Form.Item label={isMobile ? null : " "} name="allowPausesBetweenServices" valuePropName="checked" ><Checkbox disabled={!item.maintainServiceOrder}>Разрешать паузы между услугами</Checkbox></Form.Item>
            <Form.Item label="Вид прохода" name="passVid">
              <Select options={recordPassVidOptions} style={{ width: 200 }} />
            </Form.Item>
            <Form.Item label={isMobile ? null : " "}>
              <Space>
                {!item.time ? (
                  <Popconfirm
                    title="Подтверждение"
                    description="Время не выбрано, записать на доступное время?"
                    onConfirm={handleSave}
                    okText="Да"
                    cancelText="Нет"
                  >
                    <Button className="sport-btn" disabled={!canSave}>Записать</Button>
                  </Popconfirm>
                ) : (
                  <Button className="sport-btn" onClick={handleSave} disabled={!canSave} >Записать</Button>
                )}
                <Button className="sport-btn" onClick={onCancel}>Отмена</Button>
              </Space>
            </Form.Item>
          </>
        )}
        </Form>
      </div>
    </div>
  </div>
}

export default RecordsSmart;
